<template>
  <div 
    class="workflow-step"
    :class="{ 
      'active': isActive,
      'hovering': isHovering 
    }"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
    @click="handleClick"
  >
    <div class="step-number">{{ step }}</div>
    
    <div class="step-icon-wrapper">
      <div class="step-icon-bg"></div>
      <v-icon 
        :color="isActive ? 'white' : 'primary'" 
        size="36"
        class="step-icon"
      >
        {{ icon }}
      </v-icon>
    </div>
    
    <h3 class="step-title">{{ title }}</h3>
    <p class="step-description">{{ description }}</p>
    
    <div class="step-action">
      <v-btn
        text
        small
        color="primary"
        class="step-btn"
      >
        Start Now
        <v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowStep',
  
  props: {
    step: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    route: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      isHovering: false
    };
  },
  
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.workflow-step {
  position: relative;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 16px;
  background: white;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.workflow-step:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.workflow-step.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.step-number {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  transition: all 0.3s ease;
}

.workflow-step.active .step-number {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.step-icon-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
}

.step-icon-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  opacity: 0.1;
  transition: all 0.3s ease;
}

.workflow-step.active .step-icon-bg {
  opacity: 0.3;
  transform: scale(1.1);
}

.workflow-step.hovering .step-icon-bg {
  transform: scale(1.2);
  opacity: 0.2;
}

.step-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
}

.workflow-step.active .step-icon {
  transform: translate(-50%, -50%) scale(1.1);
}

.step-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #2c3e50;
  transition: color 0.3s ease;
}

.workflow-step.active .step-title {
  color: white;
}

.step-description {
  font-size: 1rem;
  color: #546e7a;
  margin-bottom: 20px;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.workflow-step.active .step-description {
  color: rgba(255, 255, 255, 0.9);
}

.step-action {
  margin-top: auto;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.workflow-step:hover .step-action,
.workflow-step.active .step-action {
  opacity: 1;
  transform: translateY(0);
}

.step-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.workflow-step.active .step-btn {
  color: white !important;
}

/* Animation for active state */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(102, 126, 234, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0);
  }
}

.workflow-step.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 16px;
  animation: pulse 2s infinite;
}

@media (max-width: 600px) {
  .workflow-step {
    min-height: 280px;
    padding: 30px 15px;
  }
  
  .step-title {
    font-size: 1.2rem;
  }
  
  .step-description {
    font-size: 0.9rem;
  }
}
</style> 